import PropTypes from 'prop-types';

/**
 * Card - Reusable card component
 * 
 * Used for: feature cards, template cards, pricing cards, etc.
 * 
 * Design System:
 * - White background with subtle shadow
 * - Rounded corners for modern look
 * - Hover effect for interactive cards
 * - Flexible children for any content
 */
const Card = ({ children, className = '', hoverable = false }) => {
  // Base styles
  const baseStyles = 'bg-white rounded-lg shadow-md';
  
  // Hover effect (optional)
  const hoverStyles = hoverable 
    ? 'transition-all duration-200 hover:shadow-xl hover:-translate-y-1 cursor-pointer' 
    : '';
  
  // Combine all styles
  const cardClasses = `${baseStyles} ${hoverStyles} ${className}`;

  return (
    <div className={cardClasses}>
      {children}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hoverable: PropTypes.bool,
};

export default Card;

